import * as axios from '~/utilities/axios'

export const signup = data => {
  return axios.basic
    .post(`/${process.env.PARSE_DIR}/users`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const update = (userObjectId, data, sessionToken) => {
  return axios
    .secure(sessionToken)
    .put(`/${process.env.PARSE_DIR}/users/${userObjectId}`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const fetchCommunicationsPreferences = sessionToken => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/user/communications/preferences`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const updateCommunicationsPreferences = (data, sessionToken) => {
  return axios
    .secure(sessionToken)
    .put(`/api/v1/user/communications/preferences`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}
